export default "/_next/static/images/header-bg-51e9b57d7fdb4094477c5a43df0f105d.png";